import React, { FC, ReactNode, useEffect, useState } from 'react'
import s from './AdvDetailed.module.sass'
import { ErrorBoundary } from '@shared/lib/components/ErrorBoundary'
import { AdvDetailedContext } from '@features/Common/AdvDetailed/Context'
import { AdvDetailedButton } from '@features/Common/AdvDetailed/ui/AdvDetailedButton'
import { AdvDetailedPopup } from '@features/Common/AdvDetailed/ui/AdvDetailedPopup'
import { AdvDetailedTooltip } from '@features/Common/AdvDetailed/ui/AdvDetailedTooltip'
import { Tooltip } from '@shared/ui/Overlays/Tooltip'
import { TooltipOptions } from '@shared/ui/Overlays/Tooltip/types/type'

interface Props {
  children: ReactNode
  openedPopup?: boolean
  className?: string
  tooltipOptions?: TooltipOptions
}

const AdvDetailed: FC<Props & React.ButtonHTMLAttributes<any>> = ({
  children,
  openedPopup,
  className = '',
  tooltipOptions = {},
}) => {
  const [context, setContext] = useState({
    floatingRelative: null,
    opened: typeof openedPopup === 'boolean' ? openedPopup : false,
  })

  useEffect(() => {
    setContext((prev) => ({
      ...prev,
      opened: openedPopup,
    }))
  }, [openedPopup])

  const handleClick = (e) => {
    e.stopPropagation()
    e.nativeEvent.preventDefault()
  }

  return (
    <ErrorBoundary>
      {/*@ts-ignore*/}
      <AdvDetailedContext.Provider value={[context, setContext]}>
        <div className={className} onClick={handleClick}>
          <Tooltip closingDelay={3000} useEvent={'click'} {...tooltipOptions}>
            {children}
          </Tooltip>
        </div>
      </AdvDetailedContext.Provider>
    </ErrorBoundary>
  )
}

const AdvDetailedNamespace = Object.assign(AdvDetailed, {
  Button: AdvDetailedButton,
  Popup: AdvDetailedPopup,
  Tooltip: AdvDetailedTooltip,
})

export default AdvDetailedNamespace
